import React from "react";
import { RotateCcw } from "react-feather";
import IconButton from "./IconButton";

export default function TagInfo(props) {

  return (
    <div className="mt-20 u-d-flex u-flex-column u-align-center u-justify-center">
      <IconButton type="button" variant="danger" onClick={props.onClick}>
        <RotateCcw />
      </IconButton>
      <p className="u-d-block u-text-center notfound-text">Nenhuma tag encontrada</p>
      <p className="u-d-block u-text-center text-color">Para add uma nova tag, você precisa selecionar o chat de um cliente e clicar no ícone de 'lápis' no box 'Tags'.</p>
    </div>
  );
}